/**
 * Created by razial on 18.03.2026.
 */

const WebSocketClientTransport = function (options) {
    cleverapps.EventEmitter.call(this);

    options = options || {};

    this.url = options.url;

    this.user = undefined;

    this.queue = [];
    this.pending = {};
    this.nextMessageId = 1;

    this.ws = undefined;

    this.opened = false;
    this.connected = false;
    this.ready = false;

    // this.trigger("connected")
    // this.trigger("disconnected")
    // this.trigger("message", message)
};

WebSocketClientTransport.prototype = Object.create(cleverapps.EventEmitter.prototype);
WebSocketClientTransport.prototype.constructor = WebSocketClientTransport;

WebSocketClientTransport.prototype.open = function (user) {
    if (!this.url || !user) {
        return;
    }

    this.user = user;

    if (!this.opened) {
        this.opened = true;

        this._connect();
    }
};

WebSocketClientTransport.prototype.close = function () {
    if (this.opened) {
        this.opened = false;

        clearTimeout(this.retryTimeout);
        this.retryTimeout = undefined;

        this._disconnect();

        const pending = this.pending;
        this.pending = {};

        const queue = this.queue;
        this.queue = [];

        Object.values(pending).forEach((entry) => {
            entry.reject();
        });

        queue.forEach((entry) => {
            entry.reject();
        });
    }
};

WebSocketClientTransport.prototype.send = function (type, data) {
    const messageId = this.nextMessageId++;

    const promise = new Promise((resolve, reject) => {
        this.queue.push({
            message: JSON.stringify({ messageId, type, data }),
            messageId,
            resolve,
            reject
        });
    });

    this._processQueue();

    return promise;
};

WebSocketClientTransport.prototype._connect = function () {
    const ws = this.ws = new WebSocket(this.url);

    ws.onopen = () => {
        console.log("WebSocketClientTransport connection opened");

        if (this.disconnectTimeout) {
            clearTimeout(this.disconnectTimeout);
            this.disconnectTimeout = undefined;
        }

        ws.send(JSON.stringify({ type: "authenticate", user: this.user }));
    };

    ws.onmessage = (event) => {
        let message;

        try {
            message = JSON.parse(event.data);
        } catch (err) {
            console.error("WebSocketClientTransport message error", event);
            return;
        }

        if (message.type === "authenticated") {
            console.log("WebSocketClientTransport connection authorized");

            this.wsReconnectElapsed = 0;

            this.ready = true;

            if (!this.connected) {
                this.connected = true;
                this.trigger("connected");
            }

            this._processQueue();
        } else if (message.type === "ack") {
            this._processAck(message.messageId);
        } else if (message.messageId) {
            ws.send(JSON.stringify({ type: "ack", messageId: message.messageId }));

            this.trigger("message", message);
        }
    };

    ws.onclose = (event) => {
        if (this.ws !== ws) {
            return;
        }

        console.log("WebSocketClientTransport connection closed", event);

        this.ready = false;
        this._requeuePending();

        if (event.code === 1000) {
            if (this.connected) {
                this.connected = false;
                this.trigger("disconnected");
            }
            return;
        }

        this.disconnectTimeout = setTimeout(() => {
            this.disconnectTimeout = undefined;

            if (this.connected) {
                this.connected = false;
                this.trigger("disconnected");
            }
        }, 5000);

        this.wsReconnectElapsed = this.wsReconnectElapsed ? this.wsReconnectElapsed * 2 : 2000 + Math.floor(Math.random() * 1000);
        this.reconnectTimeout = setTimeout(() => this._connect(), this.wsReconnectElapsed);

        console.log(`WebSocketClientTransport reconnecting in ${Math.ceil(this.wsReconnectElapsed / 1000)} sec`);
    };

    ws.onerror = (event) => {
        console.error("WebSocketClientTransport connection error", event);
    };
};

WebSocketClientTransport.prototype._disconnect = function () {
    if (this.disconnectTimeout) {
        clearTimeout(this.disconnectTimeout);
        this.disconnectTimeout = undefined;
    }

    if (this.reconnectTimeout) {
        clearTimeout(this.reconnectTimeout);
        this.reconnectTimeout = undefined;
    }

    if (this.ws) {
        this.ws.close(1000);
        this.ws = undefined;
    }
};

WebSocketClientTransport.prototype._requeuePending = function () {
    clearTimeout(this.retryTimeout);
    this.retryTimeout = undefined;

    const entries = Object.keys(this.pending)
        .sort((a, b) => a - b)
        .map((messageId) => this.pending[messageId]);

    this.pending = {};
    this.queue.unshift(...entries);
};

WebSocketClientTransport.prototype._processQueue = function () {
    if (!this.ready || !this.ws || this.ws.readyState !== WebSocket.OPEN) {
        return;
    }

    while (this.queue.length) {
        const entry = this.queue.shift();
        entry.sentAt = Date.now();

        this.pending[entry.messageId] = entry;

        this.ws.send(entry.message);
    }

    this._retryStaleMessages();
};

WebSocketClientTransport.prototype._processAck = function (messageId) {
    const entry = this.pending[messageId];
    if (entry) {
        delete this.pending[messageId];
        entry.resolve();
    }
};

WebSocketClientTransport.prototype._retryStaleMessages = function () {
    if (this.retryTimeout || !Object.keys(this.pending).length) {
        return;
    }

    this.retryTimeout = setTimeout(() => {
        this.retryTimeout = undefined;
        
        const now = Date.now();

        Object.keys(this.pending).forEach((messageId) => {
            const entry = this.pending[messageId];

            if (entry.sentAt + WebSocketClientTransport.RETRY_TIMEOUT < now) {
                delete this.pending[messageId];
                this.queue.push(entry);
            }
        });

        this._processQueue();
    }, WebSocketClientTransport.RETRY_CHECK_INTERVAL);
};

WebSocketClientTransport.RETRY_TIMEOUT = 5000;
WebSocketClientTransport.RETRY_CHECK_INTERVAL = 1000;
